import React from 'react';
import classnames from 'classnames';
import { List } from 'tea-component';
import AutoTextarea from '@gp/components/AutoTextarea';
import PriorityTag from '@gp/components/PriorityTag';
import { RISKS_TAG_MAP } from '@gp/components/RisksTag/utils/constant';

import type { IBaseProps } from '@home/types/common';
import type { IRiskVO } from '@gp/types/projectUpdate';

import './index.scss';

interface IRiskContentProps extends IBaseProps {
  risk?: IRiskVO;
}

interface IRisksContentsProps extends IBaseProps {
  risks?: IRiskVO[];
}

const RiskContent: React.FC<IRiskContentProps> = (props) => {
  const { style, className, risk } = props;

  const { category = '', rating, comment } = risk || {};
  const categoryCfg = RISKS_TAG_MAP[category] || RISKS_TAG_MAP[''];

  return (
    <div style={style} className={classnames('dbg-risk-content', className)}>
      <div className="dbg-risk-content__header">
        <span className="dbg-risk-content__dot" style={{ backgroundColor: categoryCfg?.textColor }}></span>
        <span className="dbg-risk-content__title">{category?.trim() || '-'}</span>
        {/* 分割线 */}
        <span className="dbg-vertical-divider"></span>
        <PriorityTag value={rating} />
      </div>
      <AutoTextarea className="dbg-risk-content__body" readOnly defaultValue={comment?.trim() || '-'} />
    </div>
  );
};

const RisksContents: React.FC<IRisksContentsProps> = (props) => {
  const { style, className, risks } = props;

  return (
    <>
      {risks && risks?.length > 0 && (
        <div style={style} className={classnames('dbg-risk-list-container', className)}>
          <List className="dbg-risk-list">
            {risks?.map((risk, index) => (
              <List.Item key={index} className="dbg-risk-item">
                <RiskContent risk={risk} />
              </List.Item>
            ))}
          </List>
        </div>
      )}
    </>
  );
};

export default React.memo(RisksContents);
